import React, { useState } from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import useResponsiveView from '../../../hooks/useResponsiveView'

const ICONS = {
  promo: {
    url: './../../../../imgs/misc/mb-promo.png',
    alt: 'Promo',
    width: 48,
    height: 48,
  },
  promoAlt: {
    url: './../../../../imgs/misc/mb-promoAlt.png',
    alt: 'Miles Bonus Promo',
    width: 48,
    height: 48,
  },
  success: {
    url: './../../../../imgs/misc/mb-success.png',
    alt: 'Success',
    width: 48,
    height: 48,
  },
  error: {
    url: './../../../../imgs/misc/mb-error.png',
    alt: 'Error',
    width: 48,
    height: 48,
  },
}

const StatusCard = ({ card, mbAccountData = {} }) => {
  const { type, title, description, cta } = card
  const { isDevice } = useResponsiveView()
  const { steps } = window.bookingData
  const handleCta = () => {
    if (isDevice && steps?.[0]?.path) {
      window.location.href = steps[0].path
      return
    }
    window.dispatchEvent(new CustomEvent('showBookingWidget'))
  }

  const isMBType = ['blue', 'silver', 'gold'].includes(type)
  let icon = {}

  if (isMBType && mbAccountData?.tierCardLogo) {
    icon = mbAccountData.tierCardLogo
  } else {
    icon = ICONS[type] || ICONS.promo
  }

  const [show, setShow] = useState(true)

  const handleClose = () => {
    setShow(false)
  }

  return (
    <>
      {show && (
        <div className={`b-status-card b-status-card--${type}`}>
          <div className="b-status-card__close-cta hide">
            <button
              type="button"
              className="btn"
              title="Close"
              onClick={handleClose}>
              <i className="icon-x"></i>
            </button>
          </div>
          <div className="b-status-card__image">
            {Object.keys(icon).length > 0 && (
              <img
                src={icon.url}
                alt={icon.alt}
                width={icon.width}
                height={icon.height}
              />
            )}
          </div>
          <div className="b-status-card__text">
            <h4 className="b-status-card__title">{title}</h4>
            <div className="b-status-card__description">
              <SanitizeHtml html={description} />
            </div>
          </div>
          {cta && (
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleCta}
              title={cta}>
              {cta}
            </button>
          )}
        </div>
      )}
    </>
  )
}

export default StatusCard
